<template>
	<div>
		<zongSou></zongSou>
		<div style="background: #F6F6F6;padding-bottom: 50px;">
			<div class="wrap">

				<div class="header" style="justify-content: flex-start;">
					<img src="../../assets/images/indexIcon.png" alt="">
					<p><span>首页</span><span><span class="router">-资源工具池</span></span>
					</p>
				<!-- 	<div >返回</div> -->
				</div>
			<div class="main-body">
				<div class="body-left" >
					<div class="body-left-item">
						<el-collapse v-model="activeNames" @change="handleChange" class="collapse">
							<el-collapse-item title="快速精炼" name="1">
								<div class="collapse-inner">
									<el-checkbox-group v-model="checkedJL">
										<el-checkbox v-for="(item,index) in leftList.tags":label="item.tag" :key="item.tag" v-show="index < tagsLength"><span>
												{{ item.tag }}</span> <span
												style="position: absolute;right: 0px;color: #7c7c7c;">{{item.count}}</span></el-checkbox>
									</el-checkbox-group>
								</div>
								<div class="body-left-item-foot">
									<p style="color: #0052D9;cursor: pointer;" @click="lookMore(1)">全部查看></p>
									<p>检索</p>
								</div>
							</el-collapse-item>
							<el-collapse-item title="学科" name="2">
								<div class="collapse-inner">
									<el-checkbox-group v-model="checkedXK">
										<el-checkbox v-for="(item,index) in leftList.Subject" :label="item.id" :key="item.id" v-show="index < SubjectLength"><span>
												{{ item.name }}</span> <span
												style="position: absolute;right: 0px;color: #7c7c7c;">{{item.count}}</span></el-checkbox>
									</el-checkbox-group>
									
								</div>
								<div class="body-left-item-foot">
									<p style="color: #0052D9;cursor: pointer;" @click="lookMore(2)">全部查看></p>
									<p>检索</p>
								</div>
							</el-collapse-item>
							<el-collapse-item title="行业" name="3">
				
								<div class="collapse-inner">
									<el-checkbox-group v-model="checkedHY">
										<el-checkbox v-for="(item,index) in leftList.Idustry" :label="item.id" :key="item.id" v-show="index < IdustryLength"><span>
												{{ item.name }}</span> <span
												style="position: absolute;right: 0px;color: #7c7c7c;">{{item.count}}</span></el-checkbox>
									</el-checkbox-group>
									
								</div>
								<div class="body-left-item-foot">
									<p style="color: #0052D9;cursor: pointer;" @click="lookMore(3)">全部查看></p>
									<p>检索</p>
								</div>
							</el-collapse-item>
							<el-collapse-item title="阶段" name="4">
								<div class="collapse-inner">
									<el-checkbox-group v-model="checkedJD">
										<el-checkbox v-for="(item,index) in leftList.Stage" :label="item.id" :key="item.id" v-show="index < StageLength"><span>
												{{ item.name }}</span> <span
												style="position: absolute;right: 0px;color: #7c7c7c;">{{item.count}}</span></el-checkbox>
									</el-checkbox-group>
									
								</div>
								<div class="body-left-item-foot">
									<p style="color: #0052D9;cursor: pointer;" @click="lookMore(4)">全部查看></p>
									<p>检索</p>
								</div>
							</el-collapse-item>
						</el-collapse>
					</div>
				
				</div>
				<router-view :key='$route.fullPath' :checked.sync='checkedItem' :keyWord.sync='searchWord'></router-view>
			</div>
		</div>
		</div>
	</div>
	</div>
</template>

<script>
	import {mapState,mapGetters,mapActions,mapMutations} from "vuex";
	import zongSou from '../../components/zongSou.vue'

	export default {
		data() {
			return {
				title:[],
				whereWeAre:'',
				activeNames: ['1','2','3','4'],
				searchWord:'',
				checkedJL:[],
				checkedXK:[],
				checkedHY:[],
				checkedJD:[],
				leftList:{},
				loading:false,
				StageLength:5,
				IdustryLength:5,
				SubjectLength:5,
				tagsLength:5,
			}
		},
		components:{
			zongSou
		},
		created() {
			
		},
		
		computed:{
			checkedItem(){
				return {checkedJL:this.checkedJL,checkedXK:this.checkedXK,checkedHY:this.checkedHY,checkedJD:this.checkedJD}
			},
			 ...mapState("globalSearch",{'dw':"searchWord"}),
		},
		watch: {
		    dw(newValue,oldValue){
				this.searchWord = newValue
			},
			
			$route:{
			      handler(to, from) {
					this.whereWeAre = to.path
					this.checkedJL = []
					this.checkedXK = []
					this.checkedHY = []
					this.checkedJD = []
					this.changeLeftType()
			      },
			      deep: true,
				  immediate:true
			    }
			
		 },
		methods: {
			async changeLeftType() {
				this.showLoading();
				// Solution
				let SubjectLists, IdustryLists, StageLists, tags
				if(this.whereWeAre == '/searchIndex/Solution'){
					SubjectLists =await this.$api.solutionSubjectList()
					IdustryLists =await this.$api.solutionIndustryList()
					StageLists =await this.$api.solutionStageList()
					tags = await this.$api.solutionTagsList()
				}else{
					SubjectLists = await this.$api.solutionSubjecHelptList()
					IdustryLists = await this.$api.solutionIndustryHelpList()
					StageLists = await this.$api.solutionStageHelpList()
					tags = await this.$api.solutionTagsHelpList()
				}
				this.leftList.Subject = SubjectLists.data
				this.leftList.Idustry = IdustryLists.data
				this.leftList.Stage = StageLists.data
				this.leftList.tags = tags.data
				this.checkedJL = []
				this.checkedXK = []
				this.checkedHY = []
				this.checkedJD = []
				this.loading = true
				this.hideLoading();
			},
			lookMore(type){
				switch (type) {
				  case 1:
				    if(this.tagsLength == 5){
						this.tagsLength = this.leftList.tags.length
					}else{
						this.tagsLength = 5
					}
				    break;
				  case 2:
				    if(this.SubjectLength == 5){
				    	this.SubjectLength = this.leftList.Idustry.length
				    }else{
				    	this.SubjectLength = 5
				    }
				    break;
				  case 3:
				    if(this.IdustryLength == 5){
				    	this.IdustryLength = this.leftList.Subject.length
				    }else{
				    	this.IdustryLength = 5
				    }
				    break;
					case 4:
					  if(this.StageLength == 5){
					  	this.StageLength = this.leftList.Stage.length
					  }else{
					  	this.StageLength = 5
					  }
					  break;
				  default:
				    break;
				}
			},
			getRouter(route){
				this.title.push(route.meta.title)
			},
			handleChange(val) {
				console.log(val);
			}
		},
		
	}
</script>
<style scoped lang="less">
	/deep/.el-checkbox__label:hover{
		color: #0052D9;
	}
	.router:last-child{
		color: #222222;
	}
	/deep/.el-input__inner {
		width: 129px;
		height: 40px;
		border: 1px solid #D2D2D2;
	}

	/deep/.el-collapse-item__content {
		padding-bottom: 0;
	}

	.main-body {
		display: flex;
		align-items: flex-start;
	}

	.body-left-item-foot {
		border-top: 1px solid #EEEEEE;
		display: flex;
		justify-content: space-between;
		padding: 15px;
	}

	.collapse-inner {
		padding: 10px;
	}

	.checkbox-wrap {
		display: flex;
		justify-content: space-around;
	}

	::v-deep .el-checkbox {
		color: #222222;
		display: block;
		margin: 5px !important;
		position: relative;
	}

	.body-left {
		width: 250px;

	}

	.body-left/deep/.el-collapse-item__header {
		background: #0052D9;
		height: 55px;
		font-size: 18px;
		color: white;
		padding: 0 20px;
	}

	/deep/.el-icon-arrow-right:before {
		content: "\E6E0";
		background: #fff;
		color: #0052D9;
		border-radius: 50%;
		font-weight: bold;
	}

	.header {
		display: flex;
		padding: 15px 0;
		align-items: center;

		&>img {
			width: 16px;
			height: 16px;
		}

		&>p {
			font-size: 16px;
			margin-left: 10px;

			&>span {
				color: #888888;
			}
		}
	}
</style>